import React, { useState, useEffect, useCallback } from 'react'
import { myApi } from '../../../config/axiosConfig'
import { Button, Typography, Grid2, Box } from '@mui/material'
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import Swal from 'sweetalert2';
import BtnAcciones from '../../../components/plantilla/tabla/BtnAcciones';
import ModalEditarMenu from './modals/ModalEditarMenu';
import { base_url_clean } from '../../../config/urls';

function MenuOperadores() {

    //Obtener datos de menu
    const [menus, setMenus] = useState([]);

    const [showModal, setShowModal] = useState(false);

    const [menuSelected, setMenuSelected] = useState(null);

    // ===========================================
    // USE STATE PARA SABER SI ESTA EN MODO EDITAR O CREAR
    // ===========================================
    const [isEditing, setIsEditing] = useState(false);

    const buscarMenus = async () => {

        try {

            const response = await myApi.get('/menuoperadores/select');
            setMenus(response.data.data);

        } catch (error) {

            console.error('Error al buscar menus:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un error al buscar los menus.'
            });

        }

    }

    const handleEdit = useCallback(async (menuRow) => {
        setIsEditing(true);
        setMenuSelected(menuRow);
        setShowModal(true);
    });

    const handleDelete = useCallback(async (id) => {
        Swal.fire({
            title: '¿Estás seguro de eliminar el registro?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: 'green',
            cancelButtonColor: 'red',
        }).then(async (result) => {
            if (result.isConfirmed) {
                let { data } = await myApi.put(`/menuoperadores/delete`, { menu_id: id });
                if (data.success){
                    Swal.fire({
                        icon: 'success',
                        title: 'Menú eliminado',
                    });
                    buscarMenus();
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al eliminar el menú',
                    });
                }
            }
        });
    });

    const handleInsert = useCallback(async () => {
        setIsEditing(false);
        setMenuSelected(null);
        setShowModal(true);
    });



    useEffect(() => {
        buscarMenus();
    }, []);

    const columns = [
        { field: 'name', headerName: 'Nombre', flex: 1 },
        {
            field: 'site_url', headerName: 'URL', flex: 1, renderCell: (params) => (
                <a href={params.value} target="_blank" rel="noreferrer" style={{ color: 'blue' }}>
                    {params.value}
                </a>
            )
        },
        {
            field: 'image_url', headerName: 'imagen', flex: 1, renderCell: (params) =>  {
                return (
                    <img
                        src={`${base_url_clean}img/menuOperadores${params.value}`}
                        alt="Imagen"
                        style={{ width: 50, height: 50, objectFit: 'fill', borderRadius: 4 }}
                    />
                )
            }
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            width: 150,
            getActions: (params) => [
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={() => handleEdit(params.row)}
                />,
                <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                    onClick={() => handleDelete(params.row.menu_id)}
                />
            ],
        }
    ];


    return (
        <Grid2 container>

            {/* HEADER */}

            <Grid2
                size={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >

                <Typography
                    variant="h4"
                    fontWeight={700}
                >
                    Catalogo de menus
                </Typography>

                <Box>

                    {/* BOTON PARA INSERTAR DATOS */}

                    <Button
                        variant="contained"
                        color="secondary"
                        loadingPosition="start"
                        loading={false}
                        startIcon={<BookmarkAddIcon />}
                        sx={{ marginRight: 2 }}
                        onClick={handleInsert}
                    >
                        Agregar Menu
                    </Button>

                </Box>

            </Grid2>

            {/* TABLA */}

            <Grid2 size={12} marginTop={2}>

                <MiTabla
                    data={menus}
                    columns={columns}
                    rowClick={() => { }}
                    getRowId={(row) => row.menu_id}
                />

            </Grid2>

            {/* MODAL PARA EDITAR MENUS */}

            <ModalEditarMenu
                open={showModal}
                onClose={() => setShowModal(false)}
                refresh={buscarMenus}
                data={menuSelected}
                isEditing={isEditing}
            />

        </Grid2>


    )
}

export default MenuOperadores